/*
    NOTE: all of these classes match the styles defined in `_styles.scss`
    if you change the styles here, you must also change them in `_styles.scss`
*/
// utility method for utilizing color constants set in App.css
const style = getComputedStyle(document.body);
export const sanitizePropertyValue = (value) => (
    style.getPropertyValue(value).replace(/['"]+/g, '')
);

export const H1 = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: 'var(--padding-triple)',
    letterSpacing: '-0.02em',
};

export const H2 = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: 'var(--padding-twoAndAHalf)',
    letterSpacing: '-0.02em',
};

export const H3 = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: 'var(--padding-twoAndAQuarter)',
    letterSpacing: '-0.02em',
};

export const H4 = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: 'var(--padding-twoAndAQuarter)',
    letterSpacing: '-0.02em',
};

export const H5 = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: 'var(--padding-double)',
    letterSpacing: '-0.03em',
};

export const H6 = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: 'var(--padding-double)',
    letterSpacing: '-0.02em',
};

export const H7 = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: 'var(--padding-double)',
    letterSpacing: '-0.03em',
};

export const H8 = {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 'var(--padding-oneAndAHalf)',
    letterSpacing: '-0.03em',
};

export const H9 = {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 'var(--padding-oneAndAQuarter)',
    letterSpacing: '-0.03em',
};

export const H10 = {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: 'var(--padding-double)',
    lineHeight: '32px',
    letterSpacing: '-0.03em',
};

// from execution dashboard
export const Header3 = {
    fontFamily: 'Rubik, sans-serif',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 'var(--padding-double)',
    lineHeight: 'var(--padding-triple)',
};

export const Subhead1 = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: 'var(--padding-oneAndThreeQuarters)',
    letterSpacing: '-0.02em',
};

export const InputStyle = {
    display: 'none',
};

export const Subhead2 = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: 'var(--padding-oneAndThreeQuarters)',
    letterSpacing: '-0.02em',
};

export const Subhead3 = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 'var(--padding-oneAndThreeQuarters)',
    letterSpacing: '-0.02em',
};

export const Paragraph = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 'var(--padding-oneAndThreeQuarters)',
    letterSpacing: '-0.03em',
};

export const Paragraph1 = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 'var(--padding-double)',
    letterSpacing: '-0.03em',
};

export const Paragraph2 = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: 'var(--padding-oneAndThreeQuarters)',
    letterSpacing: '-0.03em',
};

export const ParagraphBold = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: 'var(--padding-oneAndAHalf)',
    letterSpacing: '-0.02em',
};

export const Standard = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: 'var(--padding-oneAndAHalf)',
    lineWeight: 'var(--padding-double)',
    letterSpacing: '-0.02em',
    textAlign: 'left',
};

export const AvatarLarge = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: 'var(--padding-oneAndAHalf)',
    letterSpacing: '-0.025em',
    textAlign: 'center',
};

export const AvatarSmall = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: 'var(--padding-oneAndAQuarter)',
    lineWeight: 'var(--padding-double)',
    letterSpacing: ' -0.025em',
    textAlign: 'center',
};

export const navItems = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: 'var(--padding-oneAndThreeQuarters)',
    letterSpacing: '-0.03em',
};

export const Caption = {
    fontWeight: 'normal',
    fontSize: 'var(--padding-oneAndThreeQuarters)',
};

export const Caption1 = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '0.8125rem',
    letterSpacing: '-0.03em',
};

export const Caption2 = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 'var(--padding-oneAndAHalf)',
    letterSpacing: '-0.03em',
};

export const Caption3 = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: '300',
    fontSize: 'var(--padding-oneAndAHalf)',
    letterSpacing: '-0.03em',
};

export const Link = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 'var(--padding-oneAndThreeQuarters)',
    letterSpacing: '-0.03em',
};

export const Subtitle = {
    fontWeight: '500',
    fontSize: 'var(--padding-oneAndAHalf)',
};

export const Subtitle2 = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: 'var(--padding-oneAndAHalf)',
    letterSpacing: '-0.03em',
};

export const SubText = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 'var(--padding-twoAndAHalf)',
    letterSpacing: '-0.03em',
};

export const SubText1 = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 'var(--padding-twoAndAQuarter)',
    letterSpacing: '-0.03em',
};

export const Label = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: 'var(--padding-oneAndAHalf)',
    letterSpacing: '-0.02em',
};

export const LabelUpper = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 'var(--padding-oneAndAHalf)',
    letterSpacing: '-0.02em',
    transform: 'uppercase',
};

export const LabelUpperBold = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: 'var(--padding-oneAndAHalf)',
    letterSpacing: '-0.02em',
    transform: 'uppercase',
};

export const LabelAlternate = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 'var(--padding-oneAndAHalf)',
    letterSpacing: '-0.02em',
};

export const LabelModal = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: 'var(--padding-oneAndAHalf)',
    letterSpacing: '-0.02em',
};

export const LabelSmall = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '0.6875rem', // 11px as per figma
    letterSpacing: '-0.03em',
};

export const Button = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: 'var(--padding-oneAndAHalf)',
    letterSpacing: '-0.02em',
};

export const ButtonText = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: 'var(--padding-oneAndThreeQuarters)',
    letterSpacing: '-0.02em',
};

export const BreadCrumb = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: 'var(--padding-oneAndThreeQuarters)',
    letterSpacing: '-0.03em',
};

export const Status = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: 'var(--padding-oneAndThreeQuarters)',
    letterSpacing: '-0.02em',
};

export const FontFamily = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
};

export const Border = {
    border: '1px solid var(--stroke)',
    borderRadius: '0.25rem',
};

export const SearchInput = {
    fontFamily: 'var(--font_family)',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: 'var(--padding-twoAndAQuarter)',
    lineHeight: 'var(--padding-triple)',
    letterSpacing: '-0.025em',
};

export const Lozenge = {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: 'var(--padding-oneAndThreeQuarters)',
    lineHeight: 'var(--padding-triple)',
    letterSpacing: '-0.02em',
};

export const ColumnChart = {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: 'var(--padding-base)',
};

export const HealthBarCount = {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: 'var(--padding-twoAndAQuarter)',
};

export const getStatusColor = (status) => {
    switch (status) {
        case 'missed':
            return sanitizePropertyValue('--activityCardStatus_missed');
        case 'completed':
            return sanitizePropertyValue('--activityCardStatus_complete');
        case 'upcoming':
            return sanitizePropertyValue('--activityCardStatus_upcoming');
        case 'active':
            return sanitizePropertyValue('--activityCardStatus_active');
        default:
            return '';
    }
};

export const DEFAULT_TRANSITION_TIMEOUT = 160;

export const TransitionOpacity = {
    enter: 'transition-opacity-enter',
    enterActive: 'transition-opacity-enter-active',
    enterDone: 'transition-opacity-enter-done',
    exit: 'transition-opacity-exit',
    exitActive: 'transition-opacity-exit-active',
    exitDone: 'transition-opacity-exit-done',
};

export const TransitionHeight = {
    enter: 'transition-height-enter',
    enterActive: 'transition-height-enter-active',
    enterDone: 'transition-height-enter-done',
    exit: 'transition-height-exit',
    exitActive: 'transition-height-exit-active',
    exitDone: 'transition-height-exit-done',
};
